/**
 * Lecture d'un flux SSE reçu par `fetch` (l'API EventSource ne fait que des GET) : on accumule les
 * morceaux et on rend chaque événement complet (`event:` et `data:`), séparé par une ligne vide.
 */
export interface SseMessage {
  event: string;
  data: string;
}

export function createSseParser(): { feed(chunk: string): SseMessage[]; flush(): SseMessage[] } {
  let buffer = '';
  const parseBlock = (block: string): SseMessage | null => {
    let event = 'message';
    const data: string[] = [];
    for (const line of block.split('\n')) {
      if (!line || line.startsWith(':')) continue;
      const colon = line.indexOf(':');
      const field = colon === -1 ? line : line.slice(0, colon);
      const value = colon === -1 ? '' : line.slice(colon + 1).replace(/^ /, '');
      if (field === 'event') event = value;
      else if (field === 'data') data.push(value);
    }
    return data.length ? { event, data: data.join('\n') } : null;
  };
  const drain = (final: boolean): SseMessage[] => {
    buffer = buffer.replace(/\r\n?/g, '\n');
    const blocks = buffer.split('\n\n');
    buffer = final ? '' : (blocks.pop() ?? '');
    return blocks.flatMap((b) => {
      const m = parseBlock(b);
      return m ? [m] : [];
    });
  };
  return {
    feed(chunk) {
      buffer += chunk;
      return drain(false);
    },
    flush() {
      return drain(true);
    },
  };
}
